import { useEffect, useRef } from 'react'
import { getEnvVar } from '@mc/client-env'

export const NewRelic = () => {
  const agentRef = useRef<unknown>(null)

  const NEW_RELIC_APP_ID = getEnvVar<string>('NEW_RELIC_APP_ID')

  useEffect(() => {
    if (!NEW_RELIC_APP_ID || agentRef.current) return

    import('@newrelic/browser-agent/loaders/browser-agent').then(
      ({ BrowserAgent }) => {
        agentRef.current = new BrowserAgent({
          init: {
            distributed_tracing: { enabled: true },
            privacy: { cookies_enabled: true },
            ajax: { deny_list: ['bam-cell.nr-data.net'] },
          },
          info: {
            beacon: 'bam-cell.nr-data.net',
            errorBeacon: 'bam-cell.nr-data.net',
            licenseKey: 'c5a76a50d4',
            applicationID: NEW_RELIC_APP_ID,
            sa: 1,
          },
          loader_config: {
            accountID: '981762',
            trustKey: '981762',
            agentID: '1809867345',
            licenseKey: 'c5a76a50d4',
            applicationID: NEW_RELIC_APP_ID,
          },
        })
      },
    )
  }, [NEW_RELIC_APP_ID])

  return null
}
